// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const User: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 19"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M4.625 4.75a3.376 3.376 0 116.752.002 3.376 3.376 0 01-6.752-.002zm7.875 0c0-2.496-2.004-4.5-4.5-4.5a4.486 4.486 0 00-4.5 4.5c0 2.496 2.004 4.5 4.5 4.5s4.5-2.004 4.5-4.5zM1.25 17.125c0-2.777 2.285-5.063 5.063-5.063h3.375a5.064 5.064 0 015.062 5.063v.563c0 .316.246.562.563.562a.555.555 0 00.562-.563v-.562a6.197 6.197 0 00-6.188-6.188H6.313a6.197 6.197 0 00-6.188 6.188v.563c0 .316.246.562.563.562a.555.555 0 00.562-.563v-.562z" />
        </svg>
    );
};

export default React.memo(User);
